import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import { SButton } from '../../styles/components/Button';

type ButtonType = ButtonHTMLAttributes<HTMLButtonElement> & {
    text: string,
    icon?: ReactNode,
    width?: string
}

const Button = ({ text,icon, width }: ButtonType) => {
    return (
        <SButton width={width}>
            {text}
            {icon}
        </SButton>
    );
}

export default Button;